/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccessRolePermissionOverride } from './AccessRolePermissionOverride';
import {
    AccessRolePermissionOverrideFromJSON,
    AccessRolePermissionOverrideFromJSONTyped,
    AccessRolePermissionOverrideToJSON,
    AccessRolePermissionOverrideToJSONTyped,
} from './AccessRolePermissionOverride';

/**
 * 
 * @export
 * @interface UpdateEmployeeAccessRole
 */
export interface UpdateEmployeeAccessRole {
    /**
     * 
     * @type {number}
     * @memberof UpdateEmployeeAccessRole
     */
    accessRoleId: number;
    /**
     * A list of permission overrides for the employee and access role
     * @type {Array<AccessRolePermissionOverride>}
     * @memberof UpdateEmployeeAccessRole
     */
    permissionOverrides: Array<AccessRolePermissionOverride>;
}

/**
 * Check if a given object implements the UpdateEmployeeAccessRole interface.
 */
export function instanceOfUpdateEmployeeAccessRole(value: object): value is UpdateEmployeeAccessRole {
    if (!('accessRoleId' in value) || value['accessRoleId'] === undefined) return false;
    if (!('permissionOverrides' in value) || value['permissionOverrides'] === undefined) return false;
    return true;
}

export function UpdateEmployeeAccessRoleFromJSON(json: any): UpdateEmployeeAccessRole {
    return UpdateEmployeeAccessRoleFromJSONTyped(json, false);
}

export function UpdateEmployeeAccessRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEmployeeAccessRole {
    if (json == null) {
        return json;
    }
    return {
        
        'accessRoleId': json['accessRoleId'],
        'permissionOverrides': ((json['permissionOverrides'] as Array<any>).map(AccessRolePermissionOverrideFromJSON)),
    };
}

  export function UpdateEmployeeAccessRoleToJSON(json: any): UpdateEmployeeAccessRole {
      return UpdateEmployeeAccessRoleToJSONTyped(json, false);
  }

  export function UpdateEmployeeAccessRoleToJSONTyped(value?: UpdateEmployeeAccessRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessRoleId': value['accessRoleId'],
        'permissionOverrides': ((value['permissionOverrides'] as Array<any>).map(AccessRolePermissionOverrideToJSON)),
    };
}

